import { render, staticRenderFns } from "./CreditRuleMapList.vue?vue&type=template&id=c5afebbc&"
import script from "./CreditRuleMapList.vue?vue&type=script&lang=js&"
export * from "./CreditRuleMapList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports